import { useState } from "react";
import { url } from "../utils/config";
import axios from "axios";
import { toast } from "react-toastify";
import { btnCancel, btnOne, inputStyleTwo, label, title } from "../utils/style";


function DelayModal(props) {

    const [ reason, setReason ] = useState('')
    const [ duration, setDuration ] = useState('')
    const [ durationType, setDurationtype ] = useState('')

    const options = ['Some Technical Issue', 'Bad Weather Conditions'];
    const type = ['Hour', 'Minutes'];

    async function notify() {
        if(
            !reason || reason.length === 0 || reason === 'select' ||
            !duration || duration.length === 0 || duration.length === 0 ||
            !durationType || durationType.length === 0 || durationType === 'select'
        ) {
            return toast.error('Please enter valid reason & duration', { autoClose: 3000 })
        }
        try {
            const { userId } = props;
            const data = {
                title: 'Technician Delayed!',
                body: `Dear Customer, the technician will get delayed by ${duration} ${durationType}`
            };
            const reqUrl = url + '/notify_customer';
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const res = await axios.post(reqUrl, { userId, data }, { headers });
            toast.success(res.data.message, { autoClose: 3000 })
            console.log(res);
            props.setShowModal(false);
        } catch (error) {
            toast.error(error.response.data.message, { autoClose: 3000 })
        }
    }

    return(
        <div className="flex justify-center items-center bg-black fixed top-0 left-0 h-screen w-screen bg-opacity-60 p-4 z-50">
            <div className="w-full rounded-xl bg-white px-4 py-6">
                <div className={title + ' ' + 'text-center'}>Delay</div>
                <div className="text-xs p-2">The expected arrival time has passed. Please inform the customer of the delay and provide the new estimated arrival time.</div>
                <div className="px-4">
                    <div className={label}>Select Reason</div>
                    <select className={inputStyleTwo} onChange={e => setReason(e.target.value)}>
                        <option value={'select'}>--Select Reason--</option>
                        {
                            options.map((op, ind) => <option key={ind} value={op} >{op}</option>)
                        }
                    </select>
                    <div className={label}>Enter Duration</div>
                    <div className="">
                        <input className={inputStyleTwo} placeholder="Enter Duration" onChange={e => setDuration(e.target.value)} />
                        <select className={inputStyleTwo} onChange={e => setDurationtype(e.target.value)}>
                            <option value={'select'}>--Select Duration Type--</option>
                            {
                                type.map((typ, ind) => <option key={ind} value={typ} >{typ}</option>)
                            }
                        </select>
                    </div>
                    <div className="flex justify-between gap-4 mt-4">
                        <button className={btnCancel} onClick={() => props.setShowModal(false)}>Cancel</button>
                        <button className={btnOne} onClick={() => notify()}>Notify</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DelayModal;